import { render } from "./About.vue?vue&type=template&id=0c90e337"
const script = {}
script.render = render

export default script